<mat-form-field>
  <mat-label>{{placeholder}}</mat-label>
  <mat-select [(value)]="value" [compareWith]="compareWith" [disabled]="disabled" [formControl]="ChildControl" [multiple]="multiple"
              [required]="required" name="Locale">
    <mat-option *ngFor="let locale of Locales" [value]="getOnlyId ? locale.Id : locale">{{locale.Id}} {{locale.getFullLocale() ? ' / ' + locale.getFullLocale() : ''}}</mat-option>
  </mat-select>
  <span *ngIf="matSuffix" matSuffix>
        <ng-container *ngTemplateOutlet="matSuffix"></ng-container>
    </span>
</mat-form-field>
